import React from "react";
import { images } from "../../assets/images";
import DashboardWidget from "../../components/common/DashboardWidget/DashboardWidget";
import { getAllVenueOrganizer } from "../../api";
import { useState, useEffect } from "react";
import { PulseLoader } from "react-spinners";
import OrganizerListCard from "../../components/common/EventCard/OragnizerListCard";
import { Link } from "react-router-dom";

type Props = {};

/**
 * Venue dashboard — compact venue identity + organizer rows.
 * Keeps the same data/actions; layout is tighter than the old stacked cards.
 */
const HomePage = (props: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [organizerLoading, setOrganizersLoading] = useState(true);
  const [organizer, setOrganizer] = useState({
    name: "",
    email: "",
    profileImage: "",
  });
  const [organizerList, setOrganizerList] = useState<any[]>([]);

  useEffect(() => {
    const fetchOrganizers = async () => {
      setOrganizersLoading(true);
      try {
        const venueData = localStorage.getItem("venueData");
        if (venueData) {
          const venueId = JSON.parse(venueData).userId;
          const response = await getAllVenueOrganizer(venueId);
          if (response) {
            // Hide soft-deleted organizers even if an old API build still returns them.
            const active = (Array.isArray(response) ? response : []).filter(
              (org: any) => String(org?.status || "").toLowerCase() !== "deleted"
            );
            setOrganizerList(active);
          }
        }
      } catch (error) {
        console.error("Error fetching organizers:", error);
      } finally {
        setOrganizersLoading(false);
      }
    };
    fetchOrganizers();
  }, []);

  React.useEffect(() => {
    // Venue home loads organizers via getAllVenueOrganizer — skip organizer-profile thunk.
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const venueData = localStorage.getItem("venueData");
        if (venueData) {
          const parsedData = JSON.parse(venueData);
          setOrganizer(parsedData);
        }
      } catch (error) {
        console.error("Error fetching organizer profile:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="ex-dashboard">
      <div className="ex-page-header">
        <span className="ex-page-eyebrow">Venue</span>
        <h1 className="ex-page-title">
          <i className="fa-solid fa-gauge me-2" aria-hidden="true"></i>
          Dashboard
        </h1>
      </div>

      {/* Compact venue identity — not a full event-sized card */}
      <div className="ex-venue-strip">
        {isLoading ? (
          <div className="d-flex justify-content-center py-2">
            <PulseLoader color="#ee3f7c" size={5} speedMultiplier={0.6} />
          </div>
        ) : (
          <>
            <div className="ex-venue-strip-avatar">
              <img
                src={organizer.profileImage || images.profile}
                alt={organizer.name || "Venue"}
              />
            </div>
            <div className="ex-venue-strip-meta">
              <h2>{organizer.name || "Venue"}</h2>
              <span>{organizer.email}</span>
            </div>
            <Link to="/update-venue" className="ex-venue-strip-link">
              Update venue
            </Link>
          </>
        )}
      </div>

      {/* <div className="ocard-right">
								<button className="pe-4 ps-4 co-main-btn min-width" data-bs-toggle="modal" data-bs-target="#addorganisationModal"><i className="fa-solid fa-plus"></i>Add Organisation</button>
							</div> */}
      {/* <div className="main-card mt-2">
            <div className="dashboard-wrap-content">
              <div className="dashboard-report-content mt-4">
                <div className="row">
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <DashboardWidget
                      mainTitle="Total Events"
                      subTitle="12"
                      cardClass="purple"
                      icon="fa-calendar-days"
                    />
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <DashboardWidget
                      mainTitle="Total Revenue"
                      subTitle="$ 1200"
                      cardClass="red"
                      icon="fa-credit-card"
                    />
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <DashboardWidget
                      mainTitle="Total Tickets"
                      subTitle="120"
                      cardClass="info"
                      icon="fa-ticket"
                    />
                  </div>
                  <div className="col-xl-3 col-lg-6 col-md-6">
                    <DashboardWidget
                      mainTitle="Total Attendees"
                      subTitle="1200"
                      cardClass="success"
                      icon="fa-user"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}

      <div className="ex-dashboard-section-head">
        <h3>Organizers</h3>
        <span>{organizerList.length} total</span>
      </div>

      {organizerLoading ? (
        <div className="d-flex justify-content-center py-4">
          <PulseLoader color="#ee3f7c" size={10} speedMultiplier={0.6} />
        </div>
      ) : organizerList.length === 0 ? (
        <p className="ex-dashboard-empty">No organizers yet.</p>
      ) : (
        <div className="ex-org-list">
          {organizerList.map((org) => (
            <OrganizerListCard
              key={org.organizerId}
              {...org}
              venueOrganizerData={org}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HomePage;
